import { useContext, useEffect } from 'react';
import useCustomHook from '@/hooks/useCustomHook';
import { GameLoopContext } from '@/shared/GameComponents/GameLoopContext/GameLoopContext';

export default function useConceptWriteAnswer({ concept, inputRef }) {
  const game = useContext(GameLoopContext);

  const { state, actions } = useCustomHook({
    defaultState: {
      answer: '',
    },
    actions: {
      updateAnswer: (ref) => {
        actions.setState({ answer: ref.target.value });
      },
      insertCharacter: (character) => {
        actions.setState({
          answer: state.answer + character,
        });
        inputRef.current.focus();
      },
      acceptAnswer: () => {
        if (
          concept.words.some(
            (word) => word.toLowerCase() == state.answer.toLowerCase()
          )
        ) {
          game.actions.setState({ currentAnswerId: concept.id });
        } else {
          game.actions.setState({ currentAnswerId: ' ' + state.answer });
        }

        actions.setState({ answer: '' });
      },
    },
  });

  useEffect(() => {
    game.actions.setState({ playingOptionAudios: false });
  }, []);

  useEffect(() => {
    if (!game.state.givingFeedback) {
      inputRef.current.focus();
    }
  }, [game.state.givingFeedback]);

  return { state, actions };
}
